import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
// import TechServicesSection from '../../Components/Automation/TechServicesSection'
// import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
// import WhyPartnerWithUs from '../../Components/Automation/WhyPartnerWithUs'
import { ArrowRight, CheckCircle, CheckCircle2 } from 'lucide-react'
import Banner from '../../Components/Banner';
import { Helmet } from 'react-helmet-async';
import IndustriesWeServeSection from './ai/IndustriesWeServeSection';
import ContactSection from '../../Components/home/ContactSection';

const featuresData = [
    {
        id: 1,
        title: "Board Design",
        description:
            "Our embedded hardware team builds reliable PCB and SoC designs, carefully balancing performance, power use, and space for real-world, production-ready systems.",
        image: "/assets/v/item6.png",
    },
    {
        id: 2,
        title: "Evaluation Module Design",
        description:
            "Our evaluation modules make prototyping, testing, and validation easier, helping teams move faster, build with confidence, and get products ready for real-world use.",
        image: "/assets/v/item9.png",
    },
    {
        id: 3,
        title: "Testing & Certification",
        description:
            "At Mobikode, we carefully test and validate every product to ensure it’s reliable, safe, and fully compliant with industry standards.",
        image: "/assets/v/item8.jpg",
    },
    {
        id: 4,
        title: "Reference Design / Platform Development",
        description:
            "We create reliable, scalable platforms and reference designs that make hardware development easier, faster, and ready for whatever the future brings.",
        image: "/assets/v/item14.png",
    },
];

// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Cloud",
        desc: "AWS, Azure, Google Cloud",
    },
    {
        id: 2,
        title: "Data Platforms",
        desc: "Snowflake, BigQuery, Redshift, Synapse",
    },
    {
        id: 3,
        title: "BI & Visualization",
        desc: "Power BI, Tableau, Looker",
    },
    {
        id: 4,
        title: "AI & ML",
        desc: "Python, TensorFlow, PyTorch",
    },
    {
        id: 5,
        title: "Integration",
        desc: "Kafka, Airflow, dbt",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "We take complete ownership from early board bring-up to final production so you don’t have to worry about the process.",
    "Our teams are domain-focused and bring real, hands-on firmware experience to every project.",
    "We offer flexible engagement models dedicated teams, PODs, or staff augmentation based on what works best for you.",
    "Quality matters to us, so we follow a strong validation approach to ensure long-term system stability.",
    "With global delivery and cost-efficient execution, we help you scale without compromising on results.",
];

const reasonsData = [
    {
        id: 1,
        text: "Dedicated Embedded Engineering Teams",
    },
    {
        id: 2,
        text: "Project-based Embedded Development",
    },
    {
        id: 3,
        text: "Embedded QA & Validation Services",
    },
    {
        id: 4,
        text: "Staff Augmentation (Firmware, Testing, Validation Engineers)",
    },
];

const approachData = [
    {
        id: 1,
        step: "01",
        title: "Automotive & EV systems",
        desc: "Engineering safety-critical firmware for battery management, telematics, motor controllers, and AUTOSAR-compliant connected vehicle platforms.",
    },
    {
        id: 2,
        step: "02",
        title: "Industrial automation & robotics",
        desc: "Developing deterministic control logic, sensor interfacing, and robust communication protocols for PLC, SCADA, and automated manufacturing equipment.",
    },
    {
        id: 3,
        step: "03",
        title: "IoT & smart devices",
        desc: "Building ultra-low-power embedded firmware, secure edge gateways, and OTA upgrade frameworks for consumer, commercial, and enterprise hardware.",
    },
    {
        id: 4,
        step: "04",
        title: "Medical devices",
        desc: "Designing ISO 13485 compliant embedded software for patient monitoring, diagnostic systems, and connected health devices with precision reliability.",
    },
    {
        id: 5,
        step: "05",
        title: "Energy, utilities & smart infrastructure",
        desc: "Implementing smart grid telemetry, metering firmware, and remote asset monitoring systems engineered for continuous operation in harsh environments.",
    },
];

function EmbeddedSoftware() {
    return (
        <div>
            <Helmet>
                <title>
                    Embedded Software & Engineering Services | Firmware & Embedded Systems | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers embedded software and engineering services for reliable, production-ready systems, including firmware development, board design, testing, validation, reference platforms, and embedded QA."
                />

                <meta
                    name="keywords"
                    content="Embedded Services, Embedded Software Services, Embedded Engineering Services, Embedded Systems Development, Embedded Software Development, Firmware Development Services, Embedded Firmware Services, Embedded Product Development, PCB Design Services, SoC Design Services, Board Design Services, Evaluation Module Design, Embedded Testing Services, Embedded System Testing, Embedded QA Services, Embedded Validation Services, Reference Design Development, Embedded Platform Development, Automotive Embedded Systems, Industrial Embedded Systems, IoT Embedded Solutions, Medical Device Embedded Software"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/embedded-services"
                />

                <meta
                    property="og:title"
                    content="Embedded Software & Engineering Services | Firmware & Embedded Systems | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Build reliable, high-performance embedded systems with Mobikode's expertise in firmware, board design, validation, testing, reference platforms, and production-ready embedded engineering."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/embedded-services"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/v/item18.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Embedded Software & Engineering Services | Firmware & Embedded Systems | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's embedded engineering capabilities across firmware development, board design, testing, certification, reference platforms, QA, and validation for production-ready systems."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/v/item18.png"
                />
            </Helmet>
            <AiHero title="Embedded Services" text="Reliable. Real-Time. Production-Ready." imgData="/assets/v/item18.png" />
            <section className="w-full py-[60px] lg:py-[100px] bg-white overflow-hidden font-sans">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">

                        <div className="w-full lg:w-full max-w-[498px] min-h-[260px] md:min-h-[350px] lg:min-h-[420px] overflow-hidden bg-gray-50">
                            <img
                                src="/assets/what/img2.png"
                                alt="ai automation"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-3">
                                Start with the right foundation
                            </p>

                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-5">
                                Embedded Software & Systems Engineering
                            </h2>

                            <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.7] font-[500]">
                                At Mobikode, we create reliable, high-performance embedded software that powers critical devices across automotive, industrial automation, IoT, healthcare, and consumer electronics. Our team combines deep engineering expertise with careful testing to ensure everything works smoothly in real-world conditions. We focus on building firmware that’s stable, scalable, and ready for production so you can confidently deliver products that perform exactly as expected, every time.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <WhyAIAutomation heading="What We Do" approachData={featuresData} />
            {/* <TechServicesSection title="Explore Our Services" sData={services} /> */}
            <IndustriesWeServeSection approachData={approachData} />
            {/* <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            Industries We Serve
                        </h2>
                        <p className="text-[#49577A] mt-2 text-left font-graphik text-[16px]">
                            A structured path from raw data to business optimization.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                            >
                                <div className="relative z-10">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                        {item.desc}
                                    </p>
                                </div>
                                <div
                                    className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100"
                                >
                                    <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section> */}

            <section className="relative w-full bg-white ">
                <div className="relative z-10 mx-auto max-w-[1440px] px-[20px] lg:px-[80px]">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">

                        <div className="lg:col-span-5 h-full">
                            <div className="lg:sticky lg:top-28">
                                <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                                    Consulting capabilities
                                </p>
                                <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.2] tracking-tight mb-5">
                                    Engagement Models
                                </h2>
                                <p className="font-graphik font-[500] text-[14px] sm:text-[15px] lg:text-[16px] text-[#49577A] leading-[1.7] max-w-[440px]">
                                    Flexible collaboration structures built around your delivery milestones, technology stack, and scaling priorities.
                                </p>
                            </div>
                        </div>

                        <div className="lg:col-span-7 flex flex-col gap-5 sm:gap-6">
                            {reasonsData.map((item, index) => {
                                const stepNum = String(index + 1).padStart(2, '0');
                                const gradients = [
                                    "from-[#E8ECF8] via-[#ECEEFA] to-[#D5DCF5]",
                                    "from-[#E2E6EE] via-[#E8EDF4] to-[#C9D4E2]",
                                    "from-[#DFF2EB] via-[#E6F4EF] to-[#BEE6D8]",
                                    "from-[#D8E8F5] via-[#E2F0F9] to-[#BAD8EE]",
                                    "from-[#EAE7F8] via-[#EFEBF9] to-[#D5CFF3]",
                                    "from-[#E7ECF3] via-[#EFF3F8] to-[#CBD8E7]",
                                ];
                                const cardGradient = item.gradient || gradients[index % gradients.length];

                                return (
                                    <div
                                        key={item.id || index}
                                        className={`relative overflow-hidden rounded-sm bg-gradient-to-r ${cardGradient} p-7 sm:p-9 lg:p-10 transition-all duration-300 hover:shadow-lg hover:-translate-y-1`}
                                    >
                                        <span className="absolute top-4 right-6 sm:top-6 sm:right-8 font-sora text-[30px] sm:text-[40px] font-[600] text-[#01386A]/10 select-none pointer-events-none">
                                            {item.step || stepNum}
                                        </span>

                                        <div className="relative z-10 max-w-[560px]">
                                            <h3 className="font-sora text-[16px] lg:text-[20px] font-[600] text-[#01386A] tracking-tight leading-[1.3] mb-3">
                                                {item.text || item.title}
                                            </h3>

                                            {item.desc && (
                                                <p className="font-graphik text-[14px] sm:text-[15px] lg:text-[16px] text-[#2C3E55] leading-[1.65] font-[500] mb-4">
                                                    {item.desc}
                                                </p>
                                            )}

                                            <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur-sm border border-white/80 px-3.5 py-1.5 rounded-full mt-2">
                                                <div className="w-1.5 h-1.5 rounded-full bg-[#ED6800]" />
                                                <span className="font-graphik text-[12px] sm:text-[13px] font-[500] text-[#01386A]">
                                                    {item.highlight || "Tailored Engagement"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                </div>
            </section>
            <section className="w-full pt-[60px] lg:pt-[90px] bg-white">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">

                        <div className="w-full lg:w-full max-w-[498px] h-auto overflow-hidden bg-gray-50">
                            <img
                                src="/assets/what/img7.png"
                                alt="Collaborative Embedded Engineering Team"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        <div className="w-full lg:w-full p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                                Start with the right foundation
                            </p>

                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.3] tracking-tight mb-5">
                                Why Mobikode for Embedded Engineering?
                            </h2>

                            <div className="flex flex-col gap-3.5 mb-6">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3 group">
                                        <div className="mt-0.5 shrink-0">
                                            <CheckCircle2 size={18} className="text-[#ED6800]" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik text-[14px] lg:text-[16px] font-[500] leading-relaxed transition-colors duration-200 group-hover:text-[#ED6800]">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.6] font-[500] border-t border-[#E6EBEF] pt-4">
                                Partner with us for reliable, scalable, and future-ready engineering solutions that drive productivity and operational excellence.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Agentic AI Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Agentic AI Services for Enterprises
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                          Helping businesses grow with simple, smart AI solutions that improve efficiency and inspire real innovation.

                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>
                    </div>
                </div>
            </section> */}
            <br/>
            <br/>
            <br/>
            <Banner title="Embedded Services" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default EmbeddedSoftware
